import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
            I am a technologist and programmer with excellent analytical skills, known for my discipline and process-oriented mindset. 
            My passion lies in solving real-time problems and constructing highly scalable software systems using Artificial Intelligence and Machine Learning. 
            I thrive on the challenge of breaking down complex issues, meticulously analyzing each aspect of the problem, and developing innovative solutions. 
            Collaborating with diverse teams, I strive to make a meaningful impact and drive positive change through technology.
              <br />
              <br />
              I am passionate about staying abreast of technological advancements, and I believe that my experiences and skills align perfectly with the dynamic field of data science. 
              I am excited to continue learning and innovating, and I am confident that I can make significant contributions to this field. Additionally, I consider myself an empathetic person and strongly believe in acquiring skills from others.
              <br />
              <br />
              In my free time, I enjoy listening to music and playing outdoor games. 
              {/* <i>
                <b className="purple"> listening to music and playing outdoor games.  </b>
              </i>
              <br />
              <br /> */}
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/Ratinkumar"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://x.com/ratinpandey"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/ratinkumar001/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/ratin.pandey/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
